<template>
	<div>
		<div class="modal-content modal-content--in-group">
			<div class="flex flex_column flex_between">
				<div class="flex flex_column w_60 margin_top">
					<form>
						<md-field :class="[{ 'md-error': errors.has('name') }]">
							<label>{{ $t('common.name') }}</label>
							<md-input
								v-model="newContact.name"
								data-vv-name="name"
								v-validate="modelValidations.name"
								required
							></md-input>
							<span v-if="errors.has('name')" class="validation-error">{{ errors.first('name') }}</span>
						</md-field>
						<md-field :class="[{ 'md-error': errors.has('phone') }]">
							<label>{{ $t('common.phone') }}</label>
							<md-input
								v-model="newContact.phone"
								data-vv-name="phone"
								v-validate="modelValidations.phone"
								required
							></md-input>
							<span v-if="errors.has('phone')" class="validation-error">{{ errors.first('phone') }}</span>
						</md-field>

						<md-field :class="[{ 'md-error': errors.has('email') }]">
							<label>{{ $t("common.email") }}</label>
							<md-input
								v-model="newContact.email"
								data-vv-name="email"
								v-validate="modelValidations.email"
								required
							></md-input>
							<span v-if="errors.has('email')" class="validation-error">{{ errors.first('email') }}</span>
						</md-field>
					</form>
				</div>
				<div class="flex flex_end w_60 margin_top">
					<md-button v-if="isEditMode" class="md-primary" @click="saveContact">
						{{ $t("common.save") }}
					</md-button>
					<md-button v-else class="md-primary" @click="addContactInFrontEnd">
						{{ $t("common.save") }}
					</md-button>
				</div>
			</div>
			<div class="w_100 md-layout-item margin_top">
				<ag-item
					v-on:getGridApi="getGridApi"
					v-on:sortChanged="sortChanged"
					:rowData="rowData"
					:columnDefs="columnDefs"
					height-type="matchRows"
					min-height="164px"
					max-height="300px"
					:frameworkComponents="frameworkComponents"
				></ag-item>
			</div>
		</div>
		<div v-if="!isEditMode" class="flex flex_end w_100 margin_top">
				<md-button :class="{ 'md-primary': isFormValid }" @click="next" :disabled=!isFormValid>
					{{ $t("common.continue") }}
				</md-button>
			</div>
	</div>
</template>

<script>
import AgItem from "src/components/templates/agGrid/AgItem.vue";
import {validateForm} from "src/validation/validation";
import {debtorManagementApi} from "src/common/api/debtorManagementApi";

export default {
	props: {
		// frameworkComponents: Object,
		debtorId: { type: Number, default: null }
	},
	components: { AgItem },
	data() {
		return {
			defaultContact: {
				id: null,
				name: null,
				phone: null,
				email: null,
				index: null
			},
			newContact: { ...this.defaultContact },
			modelValidations: {
				name: {
					required: true
				},
				phone: {
					required: true
				},
				email: {
					required: true,
					email: true
				}
			},
			columnDefs: [],
			rowData: null,
			sorting: [],
			gridApi: null
		};
	},
	beforeMount() {
		this.setColumnDefs();
		this.updateContacts();
	},
	methods: {
		getData() {
			return this.rowData;
		},
		getList() {
			let postData = {
				columns: [],
				filters: [],
				maxResults: 100,
				offset: 0,
				sorting: this.sorting
			};

			debtorManagementApi.inspection.listDebtorContact(this.debtorId, postData)
			.then(res => {
				this.rowData = res.data;
			}).catch(this.toast)
		},
		sortChanged(sortData) {
			this.sorting = sortData;
			this.updateContacts();
		},
		updateContacts() {
			if (this.debtorId) {
				this.getList();
			} else {
				this.rowData = [];
			}
		},
		addContactInFrontEnd() {
			validateForm(this, this.$validator)
			.then(() => {
				let data = this.newContact;
				if (!data.index) {
					data.index = this.rowData.length + 1;
					this.rowData.push(data);
				} else {
					const rowIndex = this.rowData.findIndex(n => n.index === data.index);
					this.rowData[rowIndex] = { ...this.rowData[rowIndex], ...data };
					this.gridApi.setRowData(this.rowData);
				}

				this.newContact = { ...this.defaultContact };
				this.$validator.reset();
			}).catch(this.toast);
		},
		next() {
			this.$emit("next");
		},
		confirmDeleteContact(data) {
			let option = {
				title: this.$t("debtorManagement.contact.delete.confirm.title"),
				msg: this.$t("debtorManagement.contact.delete.confirm.msg"),
				confirmFun: this.deleteContact,
				params: data
			};
			this.confirmMeg(option, true);
		},
		deleteContact(data) {
			if (data.id) {
				if (this.newContact.id === data.id) {
					this.newContact.id = null;
				}
				debtorManagementApi.operation.deleteContact(data.id)
				.then(function() {
					this.getList()
				}.bind(this))
				.catch(err => {
					this.toast(err)
				})
			} else {
				const rowIndex = this.rowData.findIndex(n => n.index === data.index);
				if (rowIndex !== -1) {
					this.rowData.splice(rowIndex, 1);
				}
			}
		},
		saveContact() {
			validateForm(this, this.$validator)
			.then(() => {
				let contact = { debtorId: this.debtorId, ...this.newContact };
				debtorManagementApi.operation.saveContact(contact)
				.then(() => {
					this.getList();
					this.newContact = { ...this.defaultContact }
					this.$validator.reset();
				}).catch(this.toast);
			}).catch(this.toast);
		},
		editContact(data) {
			this.newContact = { ...data };
		},
		setColumnDefs() {
			this.columnDefs = [
				{
					headerName: this.$t("common.name"),
					minWidth: 120,
					maxWidth: 180,
					field: "name",
					sortable: true,
				},
				{
					headerName: this.$t("common.phone"),
					field: "phone",
					minWidth: 100,
					maxWidth: 160,
					sortable: true,
				},
				{
					headerName: this.$t("common.email"),
					minWidth: 200,
					field: "email",
					sortable: true,
				},
				{
					headerName: this.$t("common.actions"),
					minWidth: 80,
					maxWidth: 80,
					field: "",
					cellRendererFramework: "DebtorContactTableOperation",
					cellRendererParams: {
						editFun: this.editContact,
						delFun: this.confirmDeleteContact
					},
					pinned: "right",
				}
			];
		},
		getGridApi(gApi) {
			this.gridApi = gApi;
		},
		close() {
			this.$emit("close");
		}
	},
	computed: {
		isEditMode() {
			return this.debtorId;
		},
		isFormValid() {
			return this.rowData.length >0;
		}
	}
};
</script>
